import React from 'react';
import PropTypes from 'prop-types';
import { Fragment } from 'react';
import './styles/index.scss';
import Tooltip from '@material-ui/core/Tooltip';
import { Query } from 'react-apollo';
import { GET_SST_STATE } from './queries/sst.queries';
import Moment from 'react-moment';
import { useState } from 'react';
import { SSTDetailDialog } from './dialogs/';

const DATA_POLL_INTERVAL = 5000;

const SSTView = props => {
  const { source } = props;
  const [openDetailDialog, setOpenDetailDialog] = useState(false);

  if(source === undefined) {
    return null;
  }

  const handleDetailDialogOpen = () => {
    setOpenDetailDialog(true);
  };

  const handleDetailDialogClose = () => {
    setOpenDetailDialog(false);
  };

  return (
    <React.Fragment>
      <SSTDetailDialog
      source={source}
      open={openDetailDialog}
      onClose={handleDetailDialogClose}
      />
      <Query query={GET_SST_STATE} variables={{id: source.id}} pollInterval={DATA_POLL_INTERVAL}>
          {({ data, error, loading }) => {

            let connectionState = { connected: false, timestamp:"N/A" };
            if(data !== undefined && data.sst.connection_state != null) {
              connectionState = data.sst.connection_state;
            }

            return (
              <Tooltip placement="top" title={
                <Fragment>
                  <p>
                    {connectionState.timestamp ? <Moment format="DD.MM.YYYY HH:mm:ss">{connectionState.timestamp}</Moment> : <React.Fragment />}
                  </p>
                </Fragment>}>
                <div className={(connectionState.connected ? "sst" : "sst error")} onClick={handleDetailDialogOpen}>
                  <div className="label">{source.name}</div>
                </div>
              </Tooltip>
            );
          }}
      </Query>
    </React.Fragment>
  );
};

SSTView.propTypes = {
  source: PropTypes.object.isRequired
};

export default SSTView;